module.exports = __webpack_public_path__ + "static/media/ILIRIK_logo2.169b88e3.jpg";